import { Badge, type BadgeTone } from './Badge';

interface Props {
  matchStatus: string;
  /** Canonical id the backend stored; shown for a case correction. */
  accountId?: string | null;
}

const LABEL: Record<string, string> = {
  exact: 'Matched',
  case_corrected: 'Case corrected',
  unknown: 'No match',
};

const TONE: Record<string, BadgeTone> = {
  exact: 'success',
  case_corrected: 'brand',
  unknown: 'error',
};

function title(matchStatus: string, accountId?: string | null): string {
  switch (matchStatus) {
    case 'exact':
      return 'This id was found in your session history.';
    case 'case_corrected':
      return accountId
        ? `Stored as "${accountId}" — the casing found in your session history.`
        : 'Stored with the casing found in your session history.';
    default:
      // The silent-failure case the whole screen exists to surface.
      return 'This id has never appeared in a session. If it is a typo, that player keeps counting in your reports.';
  }
}

export function MatchBadge({ matchStatus, accountId }: Props) {
  return (
    <Badge
      tone={TONE[matchStatus] ?? 'neutral'}
      title={title(matchStatus, accountId)}
    >
      {LABEL[matchStatus] ?? matchStatus}
    </Badge>
  );
}
